import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutFuelInterfaceConfiguredLookup extends Layout {
    sourceFuelInterfaceConfigured: DataSource;
    tableFuelVendors: Table;
}
